// extracted by mini-css-extract-plugin
export var downArrow = "_af-0";
export var infoTooltipIcon = "_af-3";
export var label = "_af-1";
export var optionCard = "_af-4";
export var upArrow = "_af-2";